import { HealthGoal } from '../../redux/quiz/types'

// Copy that varies with the user's goals selection: one string per single goal,
// plus a `multiple` fallback used when more than one goal (or none, or a goal
// with no entry — e.g. lose_weight on a non-weight-loss screen) was chosen.
export type GoalCopy = Partial<Record<HealthGoal, string>> & { multiple: string }

export const pickGoalCopy = (goals: HealthGoal[] | undefined, copy: GoalCopy): string =>
  (goals?.length === 1 ? copy[goals[0]] : undefined) ?? copy.multiple

// Resolves a map of token name → GoalCopy into token name → string, ready to pass
// to ContextAwareText as `additionalTokens`.
export const resolveGoalTokens = (
  goals: HealthGoal[] | undefined,
  tokens: Record<string, GoalCopy> | undefined,
): Record<string, string> | undefined =>
  tokens && Object.fromEntries(Object.entries(tokens).map(([name, copy]) => [name, pickGoalCopy(goals, copy)]))
